(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    function showProductDescription(description) {
  // 阻止事件冒泡，避免触发链接点击
  event.stopPropagation();
  
  const contentElement = document.getElementById('productDescriptionContent');
  const modal = document.getElementById('productDescriptionModal');
  const overlay = document.getElementById('modalOverlay');
  
  contentElement.innerHTML = description;
  modal.style.display = 'block';
  overlay.style.display = 'block';
}

function closeProductDescription() {
  const modal = document.getElementById('productDescriptionModal');
  const overlay = document.getElementById('modalOverlay');
  
  modal.style.display = 'none';
  overlay.style.display = 'none';
}

// 点击遮罩层也可以关闭弹窗
document.getElementById('modalOverlay').addEventListener('click', closeProductDescription);

// 按ESC键关闭弹窗
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeProductDescription();
  }
});
  } catch(e) { console.error(e); }
})();

})();
